// These are per-user settings that are changed from the main lobby screen
// (in the "Settings" button tooltip)
export default class Settings {
  desktopNotification = false;
  soundMove = true;
  soundTimer = true;
  keldonMode = false;
  colorblindMode = false;
  realLifeMode = false;
  reverseHands = false;
  styleNumbers = false;
  showTimerInUntimed = false;
  volume = 50;
  speedrunPreplay = false;
  speedrunMode = false;
  hyphenatedConventions = false;
  createTableVariant = "No Variant";
  createTableTimed = false;
  createTableTimeBaseMinutes = 2;
  createTableTimePerTurnSeconds = 10;
  createTableSpeedrun = false;
  createTableCardCycle = false;
  createTableDeckPlays = false;
  createTableEmptyClues = false;
  createTableOneExtraCard = false;
  createTableOneLessCard = false;
  createTableAllOrNothing = false;
  createTableDetrimentalCharacters = false;
}
